import {ViewType} from "../../../../../../../../core/gd/const/views/view-type"
import AddViewPreviewDefaultForm from "../preview/forms/default-form"
import {AddView_Group, AddView_GroupType} from "../../../../../../../../core/gd-ui/add-view/@types"
import {PORTFOLIO_SUMMARY_CONFIG} from "../../../../../../../../core/gd/const/views/configs/portfolio/portfolio-summary"
import {PORTFOLIO_LIST_CONFIG} from "../../../../../../../../core/gd/const/views/configs/portfolio/portfolio-list"
import {PORTFOLIO_TABLE_CONFIG} from "../../../../../../../../core/gd/const/views/configs/portfolio/portfolio-table"
import {PORTFOLIO_BOARD_CONFIG} from "../../../../../../../../core/gd/const/views/configs/portfolio/portfolio-board"
import {PORTFOLIO_CALENDAR_CONFIG} from "../../../../../../../../core/gd/const/views/configs/portfolio/portfolio-calendar"
import {PORTFOLIO_GANTT_CONFIG} from "../../../../../../../../core/gd/const/views/configs/portfolio/portfolio-gantt"
import {Feature} from "../../../../../../../../core/gd/access-control/feature-access/const"
import {PORTFOLIO_WORKLOAD_CONFIG} from "../../../../../../../../core/gd/const/views/configs/portfolio/portfolio-workload"

// const debug = "getNewPortfolioViewItemsGrouped"
const debug = false

export default function getNewPortfolioViewItemsGrouped() {

    const res: AddView_Group[] = []

    res.push({
        type        : AddView_GroupType.GROUP,
        id          : 'portfolio',
        icon        : 'ii5-assets',
        title       : 'Portfolio',
        items       : [
            {
                typeId          : ViewType.PORTFOLIO_SUMMARY,
                iconSvg         : PORTFOLIO_SUMMARY_CONFIG.iconSvg,
                title           : PORTFOLIO_SUMMARY_CONFIG.name,
                description     : PORTFOLIO_SUMMARY_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm
            },
        ]
    })

    res.push({
        type        : AddView_GroupType.GROUP,
        id          : 'tasks',
        icon        : 'i5-tasks',
        title       : 'Task Views',
        items       : [
            {
                typeId          : ViewType.PORTFOLIO_LIST,
                iconSvg         : PORTFOLIO_LIST_CONFIG.iconSvg,
                title           : PORTFOLIO_LIST_CONFIG.name,
                description     : PORTFOLIO_LIST_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm
            },
            {
                typeId          : ViewType.PORTFOLIO_TABLE,
                iconSvg         : PORTFOLIO_TABLE_CONFIG.iconSvg,
                title           : PORTFOLIO_TABLE_CONFIG.name,
                description     : PORTFOLIO_TABLE_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm
            },
            {
                typeId          : ViewType.PORTFOLIO_BOARD,
                iconSvg         : PORTFOLIO_BOARD_CONFIG.iconSvg,
                title           : PORTFOLIO_BOARD_CONFIG.name,
                description     : PORTFOLIO_BOARD_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm
            },
            {
                typeId          : ViewType.PORTFOLIO_CALENDAR,
                iconSvg         : PORTFOLIO_CALENDAR_CONFIG.iconSvg,
                title           : PORTFOLIO_CALENDAR_CONFIG.name,
                description     : PORTFOLIO_CALENDAR_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm
            },
        ]
    })

    res.push({
        type        : AddView_GroupType.GROUP,
        id          : 'planning',
        icon        : 'i5-gantchart2',
        title       : 'Planning',
        items       : [
            {
                typeId          : ViewType.PORTFOLIO_GANTT,
                iconSvg         : PORTFOLIO_GANTT_CONFIG.iconSvg,
                title           : PORTFOLIO_GANTT_CONFIG.name,
                description     : PORTFOLIO_GANTT_CONFIG.description,
                isPro           : !gd.company.license.portfolioView(ViewType.PORTFOLIO_GANTT),
                proFeature      : Feature.GANTT,
                formComponent   : AddViewPreviewDefaultForm
            },
            {
                typeId          : ViewType.PORTFOLIO_WORKLOAD,
                iconSvg         : PORTFOLIO_WORKLOAD_CONFIG.iconSvg,
                title           : PORTFOLIO_WORKLOAD_CONFIG.name,
                description     : PORTFOLIO_WORKLOAD_CONFIG.description,
                isPro           : !gd.company.license.portfolioView(ViewType.PORTFOLIO_WORKLOAD),
                proFeature      : Feature.WORKLOAD,
                formComponent   : AddViewPreviewDefaultForm
            },
        ]
    })

    return res
}
